export default __webpack_public_path__ + "static/media/latest2.ec278e81.jpg";